import { useGitpodAPI } from "@/hooks/use-gitpod-api";
import { useListRoleAssignments } from "@/queries/group-queries";
import { toPlainProject } from "@/queries/project-queries";
import { useQuery } from "@tanstack/react-query";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { useMemo } from "react";

export function useGroupProjects(groupId: string) {
    const api = useGitpodAPI();

    const { data: assignments, isLoading: isLoadingAssignments } = useListRoleAssignments({
        resourceType: ResourceType.PROJECT,
        groupId,
    });

    const projectIds = useMemo(
        () => assignments?.assignments.map((a) => a.resourceId) ?? [],
        [assignments],
    );

    const { data: projectsData, isLoading: isLoadingProjects } = useQuery({
        queryKey: ["projects", "batch", projectIds],
        queryFn: async () => {
            const response = await api.projectService.listProjects({
                filter: { projectIds },
            });
            return response.projects.map(toPlainProject);
        },
        enabled: projectIds.length > 0,
    });

    return {
        projects: projectsData ?? [],
        isLoading: isLoadingAssignments || isLoadingProjects,
    };
}
